// extracted by mini-css-extract-plugin
export default {"Toolbar":"toolbar_Toolbar__a1X-8"};